import { createSelector } from 'reselect';

interface CartNavigationState {
  v3Order?: { abandonedCartNotificationId?: number | string | null };
  shoot?: { shootProducts?: unknown[] };
  additionalData?: { selectedStudent?: { id?: number | string } | null };
}

// Recovery clears the device gallery. Until a gallery is opened again, the
// offers page has no products or student to shop for.
export const selectKeepShoppingPath = createSelector(
  (state: CartNavigationState) => state.v3Order?.abandonedCartNotificationId,
  (state: CartNavigationState) => state.shoot?.shootProducts,
  (state: CartNavigationState) => state.additionalData?.selectedStudent?.id,
  (notificationId, products, studentId): '/dashboard' | '/v3/offers' =>
    notificationId && (!products?.length || !studentId)
      ? '/dashboard'
      : '/v3/offers',
);
